import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TenantSummaryMap, TenantSummary } from './tenant-summary.model';
import { Floor } from '@miq/domain/pv';

@Injectable()
export class TenantSummaryService {
  #tenantSummary = new BehaviorSubject<TenantSummaryMap>(new Map<number, TenantSummary>());
  tenantSummary$ = this.#tenantSummary.asObservable();

  #floorSummarys = new BehaviorSubject<Floor[]>([]);
  floorsSummary$ = this.#floorSummarys.asObservable();

  setTenantSummary(tenantSummary: TenantSummaryMap): void {
    this.#tenantSummary.next(tenantSummary);
  }

  getTenantSummary(): TenantSummaryMap {
    return this.#tenantSummary.getValue();
  }

  getTenantSummaryById(id: number): TenantSummary {
    const tenantSummary = this.#tenantSummary.getValue();
    if (tenantSummary.has(id)) {
      return tenantSummary.get(id);
    }
    return null;
  }

  clearTenantSummary(): void {
    this.#tenantSummary.next(new Map<number, TenantSummary>());
  }

  setFloorsSummary(floors: Floor[]): void {
    this.#floorSummarys.next(floors);
  }

  getFloorsSummary(): Floor[] {
    return this.#floorSummarys.getValue();
  }

  clearFloorsSummary(): void {
    this.#floorSummarys.next([]);
  }
}
